import { Sprite } from '@pixi/react'
import { useEffect, useRef, useState } from 'react'
import gsap from 'gsap'
import { Sprite as PixiSprite } from 'pixi.js'

interface AnimatedSpriteProps {
  image: string
  x: number
  y: number
  width: number
  height: number
  isSpinning: boolean
  durationInSeconds: number
  parentHover?: boolean
  hoverImage?: string
}

export const AnimatedSprite = (props: AnimatedSpriteProps) => {
  const spriteRef = useRef<PixiSprite>(null)
  const startTimeRef = useRef(Date.now())
  //
  useEffect(() => {
    const sprite = spriteRef.current
    if (!sprite) return

    const updateAnimation = () => {
      const elapsedTime = (Date.now() - startTimeRef.current) / 1000 // 計算歷時
      const progress
        = (elapsedTime % props.durationInSeconds) / props.durationInSeconds // 算進度

      if (props.isSpinning) {
        sprite.rotation = progress * Math.PI * 2
        sprite.alpha = 1
      }
      else {
        if (progress < 2 / 9) {
          sprite.rotation = (progress / (2 / 9)) * ((20 * Math.PI) / 180) // 0度轉到20度
          sprite.alpha = 1 - (progress / (2 / 9)) * 0.6 // 1減到0.4
        }
        else if (progress < 5 / 9) {
          sprite.rotation
            = ((20 - ((progress - 2 / 9) / (3 / 9)) * 40) * Math.PI) / 180 // 20度轉到-20度
          sprite.alpha = 0.4
        }
        else if (progress < 7 / 9) {
          sprite.rotation = (-20 * Math.PI) / 180 // 維持-20度
          sprite.alpha = 0.4 + ((progress - 5 / 9) / (2 / 9)) * 0.6 // 從0.4到1
        }
        else {
          sprite.rotation
            = ((-20 + ((progress - 7 / 9) / (2 / 9)) * 20) * Math.PI) / 180 // 從-20度轉回0度
          sprite.alpha = 1
        }
      }
    }

    gsap.ticker.add(updateAnimation)

    return () => {
      gsap.ticker.remove(updateAnimation)
    }
  }, [props.isSpinning, props.durationInSeconds])

  const [displayImg, setDisplayImg] = useState(props.image)
  useEffect(() => {
    if (props.parentHover) {
      if (props.hoverImage) {
        setDisplayImg(props.hoverImage)
      }
    }
    else {
      setDisplayImg(props.image)
    }
  }, [props.hoverImage, props.image, props.parentHover])

  return (
    <Sprite
      ref={spriteRef}
      image={displayImg}
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      anchor={0.5}
    />
  )
}
